interface RankingRow {
  id: string;
  name: string;
  share: number | null;
  value: string;
  provider: string;
  market: string;
  profit: number | null;
  growth: number | null;
  efficiency: number | null;
}



export function ContributionRanking({ rows, metric }: { rows: readonly RankingRow[]; metric: "gmv" | "profit" | "growth" | "efficiency" }) {
  const valueOf = (row: RankingRow) => metric === "gmv" ? row.share : row[metric];
  const available = rows.filter((row) => valueOf(row) !== null).sort((a, b) => (valueOf(b) ?? 0) - (valueOf(a) ?? 0));
  const max = Math.max(...available.map((row) => Math.max(0, valueOf(row) ?? 0)), 0);
  return available.length ? <ol className="overview-ranking-list">
    {available.slice(0, 8).map((row, index) => {
      const value = valueOf(row)!;
      const fill = metric === "gmv" ? value : max > 0 ? Math.max(0, value) / max * 100 : 0;
      const label = metric === "profit" ? `$${value.toLocaleString()}` : metric === "efficiency" ? `${value.toFixed(2)}x` : `${value.toFixed(1)}%`;
      return <li key={row.id}>
        <span className="overview-ranking-list__index" data-top={index < 3 || undefined}>{index + 1}</span>
        <span className="overview-ranking-list__name" title={`${row.provider} · ${row.market}`}>{row.name}</span>
        <span className="overview-ranking-list__bar" aria-hidden="true"><i style={{ width: `${Math.max(0, Math.min(fill, 100))}%` }} /></span>
        <span className="overview-ranking-list__value">{metric === "gmv" ? `${value.toFixed(1)}%` : label}</span>
      </li>;
    })}
  </ol> : <p className="overview-panel-empty">当前数据暂无该指标的店铺排名</p>;
}
